import React from "react";
import i18n from "../../../../i18n/i18n";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import {withRouter} from "react-router";
import {UnCodeModel} from "../../../models/unCode";
import {UnCodeService} from "../../../services/unCodeService";
import UnCodeForm from "../unCodeForm/unCodeForm";


class ModifyUnCode extends ModifyItem<UnCodeModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await UnCodeService.getUnCode(this.props.match.params?.id));
    }

    render() {
        return (
            <div className="modify-uncode modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.unCodes.actions.modifyUnCode.header"))}
                    {this.renderContent(<UnCodeForm isUpdate={true} unCodeData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyUnCode);